<p>register works!</p>
<div style="background-color: purple; height: 400px; width: 50%; margin-left: 25%;">
    <div style="position: relative; left: 50%;">
        <button class="button" style="background-color: #5CFF45; border-radius: 30px; text-decoration: none; padding-right: 50px; padding-left: 50px; padding-top: 15px; padding-bottom: 15px; border: 3px solid #FF6900;"><a style="color: black; font-weight: 500; text-decoration: none, font-size= 45px" href="http://localhost:4200/recover/${token}">CLICK</a></button>
        
        </div>
</div>

